import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import DatePicker from 'react-datepicker'

import { getCustomTimeIntervals } from '../helpers'
import { timeIntervals, generateRange } from '../../../helpers/helpers'

const AnalyticsNavbar = ({ dateRange, setDateRange = () => {} }) => {
  const { t } = useTranslation(['reservations'])
  const [showPicker, setShowPicker] = useState(false)
  const [startDate, endDate] = dateRange

  const setDates = (value) => {
    setShowPicker(false)
    setDateRange(generateRange(value))
  }

  const intervals = [...getCustomTimeIntervals(t), ...timeIntervals]

  return (
    <div className="reservations-analytics-navbar">
      <div className="reservations-analytics-navbar__filters">
        <div className="time-range">
          <span>{t('reservations:analyticsNavbar.dataReports')}</span>
          <DatePicker
            className={'input borderless reservations-date-input'}
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            placeholderText={t('reservations:analyticsNavbar.selectTimeRangePlaceholder')}
            isClearable={true}
            onChange={(range) => {
              setDateRange(range)
              range[1] && setShowPicker(false)
            }}
            onClickOutside={(e) => {
              if (intervals.includes(e.target.value)) {
                setDates(e.target.value)
              }
              setShowPicker(false)
            }}
            onCalendarOpen={() => setShowPicker(true)}
          />
          <div
            style={{ display: showPicker ? 'block' : 'none' }}
            className="interval-picker-container"
          >
            <div className="interval-picker">
              <div className="period-title">{t('reservations:analyticsNavbar.period')}</div>
              <div className="intervals-scroll">
                {intervals.map((interval, i) => (
                  <button
                    onClick={(e) => {
                      e.stopPropagation()
                    }}
                    key={interval + i}
                    value={interval}
                    className="interval"
                  >
                    {interval}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AnalyticsNavbar.propTypes = {
  dateRange: PropTypes.array,
  setDateRange: PropTypes.func,
}

export default AnalyticsNavbar
